import { Injectable, inject, PLATFORM_ID, signal, computed } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE, LANGUAGES } from 'src/app/app.constants';
import { isPlatformBrowser } from '@angular/common';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly platformId = inject(PLATFORM_ID);

  private _currentLanguage = signal<string>(DEFAULT_LANGUAGE);
  readonly currentLanguage = computed(() => this._currentLanguage());

  readonly supportedLanguages = LANGUAGES;

  constructor(private translateService: TranslateService, private intlService: IntlService) {
    translateService.addLangs(this.supportedLanguages);
    if (isPlatformBrowser(this.platformId)) {
      this.initializeLanguage();
    }
  }

  private initializeLanguage() {
    let initialLang = localStorage.getItem('lang')?.toLocaleLowerCase();
    if (!initialLang || !this.supportedLanguages.includes(initialLang)) {
      const browserLang = this.translateService.getBrowserLang() ?? DEFAULT_LANGUAGE;
      initialLang = this.supportedLanguages.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE;
    }
    this.setLanguage(initialLang);
  }

  private setLanguage(lang: string) {
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    (this.intlService as CldrIntlService).localeId = lang;
    this._currentLanguage.set(lang);
    localStorage.setItem('lang', lang);
  }

  changeLanguage(newLang: string) {
    newLang = newLang.toLowerCase();
    if (!this.supportedLanguages.includes(newLang)) return;
    this.setLanguage(newLang);
  }
}
